import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { Router, RouterModule } from "@angular/router";
import { take } from "rxjs";

@Component({
  selector: "app-error-page-dialog",
  templateUrl: "error-page-dialog.component.html",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, RouterModule],
})
export class ErrorPageDialogComponent {
  pathToDisplay;
  constructor(
    public dialogRef: MatDialogRef<ErrorPageDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      messageToDisplay: string;
      buttonToDisplay: string;
      route: string;
    },
    private router: Router
  ) {
    this.dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => this.router.navigate(["/" + this.data.route]));
  }
}
